"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useBlogLocaleNavigation, useSiteLocale } from "./CcLocaleContext";
import { parseLocaleFromPathname } from "@/lib/i18n/paths";
import { blogLocaleFromPathname } from "@/lib/blog/locales";
import { getIdleTabMessage, IDLE_TAB_DELAY_MS } from "@/lib/idle-tab-copy";
import { installIdleTabTitle } from "@/lib/idle-tab-title";

export function CcIdleTabTitle() {
  const pathname = usePathname();
  const siteLocale = useSiteLocale();
  const { navigation } = useBlogLocaleNavigation();
  const { locale } = parseLocaleFromPathname(pathname);
  const blog = navigation?.pathname === pathname.replace(/\/$/, "") ? navigation : null;
  const lang = blog?.lang ?? blogLocaleFromPathname(pathname) ?? locale ?? siteLocale;
  const message = getIdleTabMessage(pathname, lang);
  const internalPage = /^\/(?:dev|api|_next)(?:\/|$)/.test(pathname);

  useEffect(() => {
    if (internalPage) return;
    return installIdleTabTitle(message, IDLE_TAB_DELAY_MS);
  }, [message, pathname, internalPage]);

  return null;
}
